module.exports = __webpack_public_path__ + "res/30-img_game_media.21b619903fa1dbc6dc98dbedd34cc802.png";